import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { Typography } from "@parkschannel/ui";
export const FooterSectionWrapper = (param)=>{
    let { children , className  } = param;
    return /*#__PURE__*/ _jsx("section", {
        className: classNames("mb-10 flex flex-col gap-y-6 lg:mb-0", className),
        children: children
    });
};
export const FooterSectionHeading = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx(Typography, {
        component: "h5",
        variant: "bodySmall",
        className: "text-neutral-500 font-medium",
        children: children
    });
};
